import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";

const FIELDS = [
  { key: "name", label: "Nome cliente", placeholder: "PRISMA", required: true },
  { key: "access_code", label: "Codice di accesso", placeholder: "PRISMA26", required: true },
  { key: "title", label: "Titolo del sistema", placeholder: "PRISMA Dance Sport System" },
  { key: "subtitle", label: "Sottotitolo", placeholder: "PRISMA Dance Sport" },
];

export default function ClientFormDialog({ client, onClose, onSaved }) {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const isEdit = !!client?.id;

  useEffect(() => {
    if (client) setForm({ name: client.name || "", access_code: client.access_code || "", title: client.title || "", subtitle: client.subtitle || "" });
  }, [client]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (isEdit) await api.put(`/clients/${client.id}`, form);
      else await api.post("/clients", form);
      toast.success(isEdit ? "Cliente aggiornato" : "Cliente creato");
      onSaved();
    } catch (err) { toast.error(formatApiError(err)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!client} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="client-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{isEdit ? "Modifica cliente" : "Nuovo cliente"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          {FIELDS.map((f) => (
            <div key={f.key}>
              <Label className="text-sm font-semibold text-slate-700">{f.label}</Label>
              <Input
                required={f.required}
                value={form[f.key] || ""}
                placeholder={f.placeholder}
                onChange={(e) => setForm({ ...form, [f.key]: f.key === "access_code" ? e.target.value.toUpperCase().replace(/[^A-Z0-9_-]/g, "") : e.target.value })}
                className="mt-2 h-11"
                data-testid={`client-form-${f.key}`}
              />
            </div>
          ))}
          <p className="text-xs text-slate-500">Il logo si carica dalla lista clienti con il pulsante "Logo".</p>
          <Button type="submit" disabled={saving} className="w-full h-11 bg-blue-700 hover:bg-blue-800 text-white" data-testid="client-form-submit">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : isEdit ? "Salva" : "Crea cliente"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
